"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'ColumnSettingPopover',
  // 表格布局组件-列设置
  props: {
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      treeData: [{
        title: '列展示',
        key: 'all',
        children: []
      }],
      visible: false,
      expandedKeys: ['all'],
      checkedKeys: [],
      defaultSelectedKeys: []
    };
  },
  watch: {
    columns: {
      handler(val) {
        if (val.length > 0) {
          this.init();
          this.$emit('input', val);
        } else {
          this.checkedKeys = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      let _columns = _.cloneDeep(this.columns);
      _columns = _columns.filter(column => {
        // 通过 column.show 判断是否显示该 column
        if (typeof column.show === 'function') return column.show() !== false;
        return column.show !== false;
      });
      this.treeData[0].children = _columns;
      this.defaultSelectedKeys = _columns.filter(item => item.hideInSetting !== true).map(item => item.key);
      this.$nextTick(() => {
        this.checkedKeys = this.defaultSelectedKeys;
      });
    },
    handleOk() {
      if (this.checkedKeys.length === 0) return;
      const columns = _.cloneDeep(this.treeData[0].children);
      columns.map(column => {
        column.hideInSetting = !this.checkedKeys.includes(column.key);
        return column;
      });
      this.$emit('input', columns);
      this.$emit('confirm', {
        columns,
        checkedKeys: this.checkedKeys
      });
      this.visible = false;
    },
    onDrop(info) {
      const {
        node = {},
        dragNode = {}
      } = info;
      const dropPos = node.pos.split('-')[2];
      const dragPos = dragNode.pos.split('-')[2];
      const _columns = this.treeData[0].children;
      const dragSource = _columns[dragPos];
      _columns.splice(dragPos, 1);
      _columns.splice(dropPos, 0, dragSource);
    }
  }
};